function factory({ window, document, thn }) {
    const engine = {};
    /**
      * @memberOf module:bs_1043641
      * @see {@link onStateChange}
      *
      * @param {object} ctx - The context object.
      */
    engine.onStateChange = thn.debounce(thn.pageCheck, 600);
    return engine;
}

export { factory };
